import { Trans, useTranslation } from 'next-i18next';
import type { FC } from 'react';
import React, { useState } from 'react';

import { Icon } from '@/components';
import { useAuthModalsControl } from '@/store';
import { cn } from '@/utils';

interface FaqStepProps {
  className?: string;
  title: string;
  text: string;
  step: number;
}

export const FaqStep: FC<FaqStepProps> = ({ title, text, step, className }) => {
  const [isOpen, setIsOpen] = useState(false);
  const { t } = useTranslation();

  const { openAuthModal } = useAuthModalsControl();

  return (
    <div className={className}>
      <button
        type="button"
        className="flex w-full items-center gap-4 overflow-hidden py-6"
        onClick={() => {
          setIsOpen(!isOpen);
        }}
      >
        <span className="flex size-10 shrink-0 items-center justify-center rounded-full bg-blue-100 text-[15px] font-semibold leading-[20px] text-blue-500">
          {step}
        </span>
        <div className="flex grow">
          <p className="body1-bold text-left text-blue-900">{t(title)}</p>
        </div>
        <Icon
          name="chevron"
          className={cn(
            'flex size-6 shrink-0 rotate-90 text-grey-400 transition-transform duration-300 ease-in-out',
            isOpen && 'rotate-180',
          )}
        />
      </button>
      <div
        className={cn(
          'overflow-hidden md:px-[56px] transition-all duration-300 ease-in-out',
          isOpen ? 'h-auto mb-6' : 'h-0',
        )}
        style={{ maxHeight: isOpen ? '1000px' : '0px' }}
      >
        <p className="body2-blog text-grey-800">
          <Trans
            i18nKey={text}
            t={t}
            components={{
              blueText: (
                <button
                  type="button"
                  onClick={() => {
                    openAuthModal('platform');
                  }}
                  className="text-blue-500"
                />
              ),
            }}
          />
        </p>
      </div>
    </div>
  );
};
